import { useTheme } from "next-themes";

interface ThemeLogoProps {
  className?: string;
  alt?: string;
}

/** Logo that swaps for light vs dark backgrounds. */
const ThemeLogo = ({ className = "h-7 w-auto", alt = "Portal Bridge" }: ThemeLogoProps) => {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === "light" ? "/logo-dark-bg.svg" : "/logo.svg";

  return <img src={src} alt={alt} className={className} />;
};

export default ThemeLogo;
